import { FeatureConfiguration } from "..";
import { easyReorderReducer } from "./reducers";

export * from "./reducers";

export default function (config: FeatureConfiguration) {
    config.reducers.easyReorderItems = easyReorderReducer;
}
